import { gql } from '@apollo/client';

export const TRANSACTION_FRAGMENT = gql`
  fragment TransactionFragment on Transaction {
    id
    label
    type
    status
    description
    amountInCents
    reason
    date
  }
`;
